import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import HookedTextField from 'components/standard/Form/HookedTextField';

const VerifyDestroy = ({ sx, ...rest }: StackProps) => (
	<Stack sx={combineSx({ gap: 150 }, sx)} {...rest}>
		<Typography variant="label-lg" fontWeight={500}>
			To verify, type{' '}
			<Typography variant="label-lg" fontWeight={700}>
				CONTINUE
			</Typography>{' '}
			below
		</Typography>
		<HookedTextField
			name="verification_text"
			placeholder="CONTINUE"
			autoComplete="off"
			fullWidth
		/>
	</Stack>
);

export default VerifyDestroy;
